import { makeGetRequest, makeFormRequest, makeDeleteRequest, Response, OkResponse } from '../helpers';
import { CalendarConsultation } from '@/types/models/calendar';
import { ReservedSlot, Slot } from '@/components/calendar/types';

import {BackendSlotReserved, SlotsClinic, SlotsCustom, transformReservedSlot} from './backend';

import { transformScheduleTemplate, transformScheduleDate } from '@/store/doctors/backend';
import { discardTime } from '@/utils/date';

import { ScheduleSetForm, ScheduleEditForm } from '@/components/calendar/forms/schedule/types';
import { BackendSlotsRequest, SlotsRequest, BackendSlots, Slots, transformSlots, transformCalendarConsultation } from './backend';
import { ISODateRange, ISOCalendarDate } from '@/utils/date/types';

import { Entity } from '@/types/common';

const buildQueryParams = (params: Record<string, any>): string => {
    const searchParams = new URLSearchParams(params);
    const query = searchParams.toString();

    return query ? `?${query}` : '';
}

// slots

export const getMonthSlots = async ({ doctorId, range }: SlotsRequest): Promise<[Slots, SlotsClinic, SlotsCustom]> => {
    const backendParams: BackendSlotsRequest = {
        doctorId: doctorId,
        dateTimeStart: range.start,
        dateTimeEnd: range.end,
    };
    const query = buildQueryParams(backendParams);
    
    const response = await makeGetRequest<Response<BackendSlots>>(`api/calendars/month${query}`);
    const calendar = response.data.result;

    return transformSlots(calendar);
}

export const getSlots = async ({ doctorId, range }: SlotsRequest): Promise<BackendSlots> => {
    const backendParams: BackendSlotsRequest = {
        doctorId: doctorId,
        dateTimeStart: range.start,
        dateTimeEnd: range.end,
    };
    const query = buildQueryParams(backendParams);
    
    const response = await makeGetRequest<Response<BackendSlots>>(`api/calendars/month${query}`);
    return response.data.result;
}

// consultations

export const createConsultation = async (doctorId: number, consultation: CalendarConsultation): Promise<ReservedSlot> => {
    const backendConsultation = transformCalendarConsultation(doctorId, consultation);
    const response = await makeFormRequest<Response<BackendSlotReserved>>(`api/calendars`, { ...backendConsultation });
    
    const backendSlot = response.data.result;
    const date = discardTime(consultation.start);
    const slot = transformReservedSlot(backendSlot, date);

    return slot;
}

// schedule
export const updateScheduleTemplate = async (doctorId: number, schedule: ScheduleSetForm) => {
    const scheduleTemplate = transformScheduleTemplate(schedule);

    await makeFormRequest<OkResponse>(`api/doctors/${doctorId}/schedule`, scheduleTemplate);
}

export const updateScheduleDate = async (doctorId: number, schedule: ScheduleEditForm): Promise<Slot[]> => {
    const scheduleDate = transformScheduleDate(schedule);

    // returns object with single date
    const response = await makeFormRequest<Response<BackendSlots>>(`api/doctors/${doctorId}/schedule/update`, scheduleDate);
    const backendSlot = response.data.result

    const slots = transformSlots(backendSlot)[0];

    return slots[schedule.date]
}

export const removeScheduleDate = async (doctorId: number, date: ISOCalendarDate): Promise<void> => {
    const response = await makeDeleteRequest<OkResponse>(`api/doctors/${doctorId}/schedule?date=${date}`)
    
    if (response.data.result.status !== 'ok') {
        throw new Error('Bad status');
    }
}

export const createVacation = async (doctorId: number, dates: ISODateRange): Promise<void> => {
    await makeFormRequest<Response<Entity>>(`api/doctors/${doctorId}/vacation`, {
        dateStart: dates.start,
        dateEnd: dates.end,
    })
}

export const updateVacation = async (doctorId: number, vacationId: number, dates: ISODateRange): Promise<void> => {
    const response = await makeFormRequest<OkResponse>(`api/doctors/${doctorId}/vacation/update`, {
        vacationId,
        dateStart: dates.start,
        dateEnd: dates.end,
    })
    
    if (response.data.result.status !== 'ok') {
        throw new Error('Bad status');
    }
}

export const removeVacation = async (doctorId: number, vacationId: number): Promise<void> => {
    const response = await makeDeleteRequest<OkResponse>(`api/doctors/${doctorId}/vacation?vacationId=${vacationId}`)
    
    if (response.data.result.status !== 'ok') {
        throw new Error('Bad status');
    }
}
